module.exports = __webpack_public_path__ + "static/pro-development-section-6@2x-a79e8cba84317ba92110c5cc9b4f0802.png";